/**
 * static 目录下资源 URL（与 CopyWebpackPlugin 输出一致）
 * 生产环境 publicPath 为 ./ ，需使用相对路径
 */
export function staticRootPrefix() {
	return process.env.NODE_ENV === 'production' ? './static/' : '/static/';
}

/** @param {string} fileName 仅文件名，位于 static/home/1-2p/ */
export function staticHome1_2pFile(fileName) {
	return staticRootPrefix() + 'home/1-2p/' + fileName.split('/').map(encodeURIComponent).join('/');
}



// WEBPACK FOOTER //
// ./src/utils/staticUrl.js